import { ReactComponent as NumberedListIcon } from 'assets/icons/listNumbered24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useNumberedListToggle } from 'common/Prose/Toolbar/hooks/useNumberedListToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import MStyles from '../MobileToolbar.module.scss'

export const NumberedListButton = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active: selected, handleClick } = useNumberedListToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Turn into numbered list"
      className={cx(MStyles.button, {
        [MStyles.buttonSelected]: selected,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-numbered-list-mark"
      {...props}
    >
      <NumberedListIcon />
    </Button>
  )
})
